/** Content-sidebar panel id used by the artifact preview pane. */
export const ARTIFACT_PANEL_ID = "artifact"
